import React from "react";
import { useSearchParams } from "react-router-dom";

import {
  Filter,
  getURLParams,
  resetURLParams,
} from "@/common/components/quick-filters/quick-filters.utils";

const useFilterClickHandler = (filters: Filter[], activeFilter?: Filter) => {
  const [, setSearchParams] = useSearchParams();

  return React.useCallback(
    (index: number) => {
      const filter = filters[index];
      const urlParams = getURLParams(filters[index]);
      const shouldReset = filter.label === activeFilter?.label;
      setSearchParams((cur) => {
        if (shouldReset) {
          resetURLParams(cur);
        } else {
          Object.entries(urlParams).forEach(([key, value]) =>
            cur.set(key, value),
          );
        }
        return cur;
      });
    },
    [activeFilter?.label, filters, setSearchParams],
  );
};

const useEnforcePlans = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const enforcePlans = searchParams.get("enforcePlans");

  const handlePlanPurchaseClick = () => {
    setSearchParams((c) => {
      c.set("enforcePlans", "true");
      return c;
    });
  };

  const handleClosePlans = () => {
    setSearchParams((c) => {
      c.delete("enforcePlans");
      return c;
    });
  };

  return { enforcePlans, handleClosePlans, handlePlanPurchaseClick };
};

export { useEnforcePlans, useFilterClickHandler };
